<template>
    <div class="mt-3">
        <div :key="options.length" class="options row">
            <h5 class="col-12 text-uppercase bg-light text-center py-1">
                Options
            </h5>
            <div class="col-12">
                <div class="btn btn-info my-2" @click="addOption">
                    Add Option
                </div>
            </div>
            <div
                v-for="(option, index) in options"
                :key="index"
                class="option col-12 form-group d-flex"
            >
                <div class="col-11">
                    <input
                        v-model="options[index]"
                        type="text"
                        class="form-control"
                        dir="auto"
                        @blur="optionChanged"
                    />
                </div>
                <div
                    class="col-1 d-flex justify-content-center align-items-center"
                >
                    <button class="btn btn-danger" @click="deleteOption">
                        <i class="far fa-trash-alt" />
                    </button>
                </div>
            </div>
        </div>
        <div v-if="type === multiSelectType" class="other d-flex">
            <div class="form-group col-12 col-md-6">
                <label for="min">
                    Min options:
                </label>
                <input
                    id="min"
                    v-model="settings.minOptions"
                    type="number"
                    class="form-control"
                    @blur="emitSettings"
                />
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="max">
                    Max options:
                </label>
                <input
                    id="max"
                    v-model="settings.maxOptions"
                    type="number"
                    class="form-control"
                    @blur="emitSettings"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    props: {
        type: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            settings: {},
            options: []
        };
    },

    computed: {
        ...mapGetters({
            multiSelectType: 'questions/MULTI_SELECT'
        })
    },

    created() {
        this.settings = cloneDeep(this.value);

        if (!this.settings.options) {
            this.settings.options = [];
        }

        this.options = cloneDeep(this.settings.options);
    },

    methods: {
        addOption() {
            this.options.push('');
        },

        optionChanged() {
            this.settings.options = cloneDeep(this.options);
            this.emitSettings();
        },

        emitSettings() {
            this.$emit('input', this.settings);
        },

        deleteOption(index) {
            this.options.splice(index, 1);

            this.optionChanged();
        }
    }
};
</script>
